import {
  GET_ADMIN_DASHBOARD_SUCCEEDED,
  GET_ADMIN_DASHBOARD_FAILED,
  GET_ADMIN_DASHBOARD,
  GET_ANALYTICS_USER,
  GET_ANALYTICS_USER_SUCCEEDED,
  GET_ANALYTICS_USER_FAILED,
  GET_LOGIN_DEVICES_BY_ID_REQUEST,
  GET_LOGIN_DEVICES_BY_ID_SUCCEEDED,
  GET_LOGIN_DEVICES_BY_ID_FAILED,
} from '../../src/actions';
import { IDashboard } from '../interfaces/dashboard';
import { getLocalStore } from 'next-persist';

const initialState: IDashboard = {
  adminDashboard: {},
  analyticsUser: {
    live_user_count: [],
    users_last_hour: [],
    total_last_hour_user: 0,
  },
  getAdminDashboardStatus: '',
  getAnalyticsUserStatus: '',
  getAllLoginDevicesStatus: '',
  loginDevices: {
    data: [],
  },
};
const persistedState = getLocalStore('dashboard', initialState);

const dashboard = (state = persistedState, action) => {
  switch (action.type) {
    case GET_ADMIN_DASHBOARD:
      return {
        ...state,
        getAdminDashboardStatus: 'request',
      };
    case GET_ADMIN_DASHBOARD_SUCCEEDED:
      return {
        ...state,
        adminDashboard: action.data,
        getAdminDashboardStatus: 'success',
      };

    case GET_ADMIN_DASHBOARD_FAILED:
      return {
        ...state,
        getAdminDashboardStatus: 'failure',
      };
    case GET_ANALYTICS_USER:
      return {
        ...state,
        getAnalyticsUserStatus: 'request',
      };
    case GET_ANALYTICS_USER_SUCCEEDED:
      return {
        ...state,
        analyticsUser: action.data,
        getAnalyticsUserStatus: 'success',
      };
    case GET_ANALYTICS_USER_FAILED:
      return {
        ...state,
        getAnalyticsUserStatus: 'failure',
      };
    case GET_LOGIN_DEVICES_BY_ID_REQUEST:
      return {
        ...state,
        getAllLoginDevicesStatus: 'request',
      };

    case GET_LOGIN_DEVICES_BY_ID_SUCCEEDED:
      return {
        ...state,
        getAllLoginDevicesStatus: 'success',
        loginDevices: {
          data: action.data.data,
        },
      };

    case GET_LOGIN_DEVICES_BY_ID_FAILED:
      return {
        ...state,
        getAllLoginDevicesStatus: 'failed',
      };
    default:
      return state;
  }
};

export default dashboard;
